// extracted by mini-css-extract-plugin
export default {"admin_dashboard":"Admin_admin_dashboard__2r9-O","header_mainContent":"Admin_header_mainContent__CndV4"};